module.exports = __webpack_public_path__ + "static/media/282.96829a37.wav";